import React from 'react';
import { useSelector } from 'react-redux';
import {
  PlanCancelSubscriptionOption,
  PlanCancelWizardStep,
  PlanDetails,
  PlanTypes,
} from 'Interfaces/Billing';
import { CancellationReason } from 'Interfaces/UserFeedbacks';
import { selectUserPlan } from 'Utils/selectors';

import { wizardComponentByStepAndPlan } from './common/wizardComponentByStepAndPlan';
import BillingCancelPlanWizardYourThoughtsForm from './BillingCancelPlanWizardYourThoughtsForm';

export interface BillingCancelPlanWizardConfirmFormProps {
  subscriptionOption: PlanCancelSubscriptionOption;
  cancellationReason: CancellationReason;
  step: PlanCancelWizardStep;
  pristine?: boolean;
  isSubmitting?: boolean;
  hasValidationErrors?: boolean;
  onSecondStep: () => void;
  onLastStep: () => void;
  onSubmitDiscountIncrease: () => void;
  onCancel?: () => void;
}

const BillingCancelPlanWizardConfirmForm = ({
  step,
  subscriptionOption,
  cancellationReason,
  pristine,
  isSubmitting,
  hasValidationErrors,
  onSecondStep,
  onLastStep,
  onSubmitDiscountIncrease,
  onCancel,
}: BillingCancelPlanWizardConfirmFormProps) => {
  const userPlan: PlanDetails = useSelector(selectUserPlan);

  const planType = userPlan?.type || PlanTypes.FREE;

  const config =
    wizardComponentByStepAndPlan[step]?.[subscriptionOption]?.[planType]?.[
      cancellationReason
    ];

  if (!config || !config.Component || !config.getProps) {
    return (
      <BillingCancelPlanWizardYourThoughtsForm
        onCancel={() => onCancel?.()}
        onSubmit={onLastStep}
        isSubmitting={isSubmitting}
      />
    );
  }

  const { Component, getProps } = config;

  return (
    <Component
      {...getProps({
        step,
        subscriptionOption,
        cancellationReason,
        pristine,
        isSubmitting,
        hasValidationErrors,
        onSecondStep,
        onLastStep,
        onSubmitDiscountIncrease,
        onCancel,
      })}
    />
  );
};

export default BillingCancelPlanWizardConfirmForm;
